export default __webpack_public_path__ + "static/media/gif2.d223f256.gif";